// @flow

import React from 'react';
import _ from 'lodash';
import { connectRouter } from 'redux-router-kit';

import { GET_HELP_CTA } from '@zapier/product-get-help';
import { removeFromUrl } from '@zapier/url-utils';

import HelpButton from 'app/common/components/HelpButton/HelpButton';
import z from 'app/common/z';

const HIDDEN_PAGE_TYPE = 'hidden';

type HelpButtonContainerProps = {
  router: () => void,
  routeTo: (route: string) => void,
};

const routeMatches: Object = {
  '/help/': {
    pageType: 'help',
    onClick: ({ router, routeTo }) => {
      const { current } = router;
      // If this window was opened from a contact form, go back to that window.
      // This probably needs some work or maybe it should be removed?
      if (window.opener && (window.name = 'contact-search-results')) {
        window.close();
      }
      const currentUrl = removeFromUrl(String(current.url));
      routeTo(`/app/contact-us?from_url=${encodeURIComponent(currentUrl)}`);
    },
  },
  '/developer/start': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/developer/documentation': {
    pageType: 'developer',
    onClick: '/app/contact-us/',
  },
  '/developer/': {
    pageType: 'developer',
    onClick: ({ routeTo }) => {
      const maybeApp = _.get(z, ['app', 'developer', 'app']);
      const selectedApi = maybeApp ? maybeApp.selectedApi() : '';
      const url = selectedApi
        ? `/app/contact-us/dev-app/${encodeURIComponent(selectedApi)}`
        : '/developer/documentation';
      routeTo(url);
    },
  },
  '/contact': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/contact-us': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/editor/': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/': {
    pageType: 'other',
    onClick: '/help/',
  },
};

/**
 * If we're viewing a shared Zap in the conversational
 * setup we want to hide the "Get Help" button
 */
const isSharedZapConversationalSetup = props => {
  const {
    router: { current: { url = '/', query: { conv = false } = {} } = {} },
  } = props;
  return /\/shared\//.test(url) && conv;
};

const HelpButtonContainer = (props: HelpButtonContainerProps) => {
  const findMatch = () => {
    const { router } = props;
    const { current } = router;
    const url = (current ? current.url : '/') || '/';
    const matchKey =
      _.find(Object.keys(routeMatches), key => url.includes(key)) ||
      routeMatches['/'];
    return routeMatches[matchKey];
  };

  const onClick = () => {
    const { routeTo } = props;
    const match = findMatch();

    if (_.isString(match.onClick)) {
      routeTo(match.onClick);
    }
    if (_.isFunction(match.onClick)) {
      match.onClick(props);
    }
  };

  const match = findMatch();
  const shouldHideButton =
    match.pageType === HIDDEN_PAGE_TYPE ||
    isSharedZapConversationalSetup(props);

  return (
    <HelpButton
      children={GET_HELP_CTA.split(' ')
        .map(_.capitalize)
        .join(' ')}
      icon={'help'}
      onClick={onClick}
      shouldHideButton={shouldHideButton}
    />
  );
};

export default connectRouter(HelpButtonContainer);
